import { useLoginStyles } from './useLoginStyles';

export const Login = () => {
  const classes = useLoginStyles();

  return <div className={classes.root}></div>;
};
